import { Price } from "@components/Typography"
import styled from "styled-components"

export const PriceEl = styled(Price)`
  color: ${(p) => p.theme.colors.text.light};
  font-size: 1rem;
  font-weight: normal;
`
